exports.components = {
  "component---src-core-pages-page-template-js": () => import("./../../../src/core/pages/PageTemplate.js" /* webpackChunkName: "component---src-core-pages-page-template-js" */),
  "component---src-core-share-share-block-template-tsx": () => import("./../../../src/core/share/ShareBlockTemplate.tsx" /* webpackChunkName: "component---src-core-share-share-block-template-tsx" */)
}

